import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '@/store';
import { 
  setMode, 
  setColorScheme, 
  toggleMode, 
  useSystemPreference 
} from '@/store/slices/themeSlice';
import { ThemeState } from '@/types/store';

/**
 * Hook for accessing and manipulating theme state
 * @returns Theme state and action dispatchers
 */
export function useTheme() {
  const theme = useSelector((state: RootState) => state.theme);
  const dispatch = useDispatch();

  return {
    // Theme state
    ...theme,
    
    // Theme actions
    setMode: (mode: 'light' | 'dark') => dispatch(setMode(mode)),
    setColorScheme: (scheme: 'default' | 'blue' | 'green' | 'purple') => 
      dispatch(setColorScheme(scheme)),
    toggleMode: () => dispatch(toggleMode()),
    useSystemPreference: () => dispatch(useSystemPreference()),
    
    // Helper for checking if in dark mode
    isDarkMode: theme.mode === 'dark',
    
    // Color getters
    getColor: (colorName: keyof Omit<ThemeState, 'mode' | 'colorScheme' | 'systemPreference'>) => 
      theme[colorName],
    
    // CSS variable helpers
    getCssVar: (name: string) => `var(--${name})`,
  };
}

export default useTheme; 